<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/contracts"></back-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4>
            <u>Λίστα παρουσιών - {{ KidFullName }}</u>
          </h4>
        </div>
      </div>
      <div class="col-md-1" style>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid
          :data-source="attendanceRecords"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          key-expr="Id"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          :ref="dataGridRefKey"
          @onContentReady="onContentReady"
        >
          <DxPaging :page-size="20" :enabled="false" />
          <DxEditing :allow-updating="true" :use-icons="true" mode="cell" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxSearchPanel :visible="true" />

          <!--  <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">
                </DxColumn> -->

          <DxColumn
            caption="Μήνας"
            :allow-editing="false"
            data-field="AttendanceDto.AttendanceDate"
            data-type="date"
            :visible="true"
            width="250px"
            alignment="left"
            :group-index="0"
            :calculateGroupValue="calculateGroupValue"
            :customize-text="customText"
          >
          </DxColumn>

          <DxColumn
            caption="Ημερομηνία"
            width="150px"
            :allow-editing="false"
            data-field="AttendanceDto.AttendanceDate"
            data-type="date"
            :visible="true"
            alignment="left"
          >
          </DxColumn>

          <DxColumn
            :allow-editing="false"
            caption="Είσοδος"
            data-field="HasAttended"
            data-type="boolean"
            width="150px"
            :visible="true"
            alignment="center"
          >
          </DxColumn>

          <DxColumn
            :allow-editing="false"
            caption="Ώρα Εισόδου"
            data-field="DisplayStartTime"
            data-type="datetime"
            width="150px"
            :visible="true"
            alignment="center"
            :editorOptions="timeSettings"
            format="HH:mm"
          >
          </DxColumn>

          <DxColumn
            :allow-editing="false"
            caption="Έξοδος"
            data-field="HasExited"
            data-type="boolean"
            width="150px"
            :visible="true"
            alignment="center"
          >
          </DxColumn>

          <DxColumn
            :allow-editing="false"
            caption="Ώρα Εξόδου"
            data-field="DisplayEndTime"
            data-type="datetime"
            width="150px"
            :visible="true"
            alignment="center"
            :editorOptions="timeSettings"
            format="HH:mm"
          >
          </DxColumn>

          <DxColumn
            caption="Επιβεβαιωμένη"
            data-field="IsValid"
            data-type="boolean"
            width="200px"
            :visible="true"
            alignment="center"
            :allow-editing="false"
          >
          </DxColumn>
          <DxGrouping :auto-expand-all="false" />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import BackButton from "../../components/shared/backButton";
import { DxSelectBox } from "devextreme-vue/select-box";
import DxDateBox from "devextreme-vue/date-box";
import { DxButton as DxButton2 } from "devextreme-vue/button";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxGrouping,
  DxLookup,
  DxButton as GridButton,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import {
  DxDropDownOptions,
  DxLookup as DxLookup2,
} from "devextreme-vue/lookup";
import { DxPopup } from "devextreme-vue/popup";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import { formatDate } from "devextreme/localization";

export default {
  props: ["cId"],
  components: {
    BackButton,
    DxDataGrid,
    DxGrouping,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxLoadIndicator,
  },
  data() {
    return {
      dataGridRefKey: "attendancesDataGrid",
      date: this.$moment().format("MM/DD/YYYY"),
      maxDate: this.$moment().format("MM/DD/YYYY"),
      structures: [],
      AttendanceStartTime: "",
      AttendanceEndTime: "",
      attendanceRecords: [],
      absenseReasons: [],
      unlockReasons: [],
      selectedStructureId: 0,
      unlockPopupIsVisible: false,
      selectedAttendanceId: 0,
      selectedAttendanceRecordId: 0,
      selectedUnlockReasonId: 0,
      selectedUnlockRasonDescription: "",
      AttendanceIsLocked: true,
      remainingMinutesToLock: 0, //min
      unlockDuration: 0,
      attendanceRecordTimer: null,
      disabledDates: [],
      loadIndicatorVisible: false,
      isEditable: false,
      timeSettings: { type: "time", displayFormat: "HH:mm" },
      KidFullName: "",
      months: [],
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    dataGrid: function () {
      var instance = this.$refs[this.dataGridRefKey].instance;
      instance.collapseAll();
      return instance;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      const res = await mainService.get(
        `/structures/GetStructuresByUserAndOrganization?organizationId=${this.organizationId}`
      );
      this.structures = res.data;
      if (this.structures.length > 0) {
        this.selectedStructureId = this.structures[0].Id;
        await this.getAttendanceRecords();
      } else this.attendanceRecords = [];
    },
  },
  methods: {
    calculateGroupValue(e) {
      let parsedDate = new Date(Date.parse(e.AttendanceDto.AttendanceDate));
      var month = parsedDate.getMonth();
      month = month + 1;
      //var test = formatDate(parsedDate, "month");
      var monthDesc = "";
      if (month == 8) monthDesc = "ΑΥΓΟΥΣΤΟΣ";
      else monthDesc = this.months.find((x) => x.Id == month).Description;
      return month + ";" + monthDesc;
    },
    onContentReady(e) {
      this.dataGrid.collapseAll();
    },
    customText(e) {
      
      var customGroupText = e.value.split(";")[1];
      return customGroupText;
    },
  },
  created() {},
  async mounted() {
    const res1 = await mainService.get(
      `/Periods/GetAvailableMonthsInActivePeriod`
    );
    this.months = res1.data;
    const res = await mainService.get(
      `/attendances/GetKidAttendanceRecords?id=${this.cId}&organizationId=${this.organizationId}`
    );
    this.attendanceRecords = res.data;
    this.KidFullName =
      res.data[0].ContractDto.KidDto.LastName +
      " " +
      res.data[0].ContractDto.KidDto.FirstName;
  },
  destroyed() {
    clearTimeout(this.attendanceRecordTimer);
    this.attendanceRecordTimer = null;
  },
};
</script>

<style>
</style>
